﻿let data;

function markAsLoading() {
    $('#car-launch-results-container').text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}

function reloadQuery() {
    const State = History.getState();
    $.ajaxSetup({cache: false});
    $.get('/car-launch/running-costs/query', State.data, function (response) {
        $('#car-launch-query-container').replaceWith(response);
    });
}

function setOperatingCycle() {
    $.get("/cap-operating-cycles/miles/" + $('#DefaultOperatingCycleId').val(), function (response) {
        $("#Miles").val(response);
    });
    $.get("/cap-operating-cycles/years/" + $('#DefaultOperatingCycleId').val(), function (response) {
        $("#Years").val(response);
    });
}

function buildUpQueryString(data) {
    let queryString = "";
    const operatingCycleDefault = $('#OperatingCycleId option').eq(0).val();
    if (data.OperatingCycleId != operatingCycleDefault) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Years=" + data.Years + "&Miles=" + data.Miles + "&ModelGroupId=" + data.ModelGroupId + "&DerivativeId=" + data.DerivativeId;
    }
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.imageId) > 0) {
        queryString += "image=" + data.imageId;
    } else {
        queryString += "image=";
    }
    if (data.ModelYear !== "") {
        queryString += "&ModelYear=" + data.ModelYear;
    }
    return "?" + queryString;
}

function getData(page) {
    const operatingCycleId = $('#OperatingCycleId').val();
    const miles = $('#Miles').val();
    const years = $('#Years').val();
    const modelGroupId = $('#ModelGroupId').val();
    const imageId = $('#Image').val();
    const derivativeId = $('#DerivativeId').val();
    const modelYear = $('#ModelYear').val();
    return {
        OperatingCycleId: operatingCycleId,
        Miles: miles,
        Years: years,
        DerivativeId: derivativeId,
        imageId: imageId,
        ModelGroupId: modelGroupId,
        ModelYear: modelYear
    };
}

function updateRunningCostsLogic(page) {
    const data = getData(page);
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}

function onImageSliderChange(event) {
    const image = $(event.target.currSlide.content).data('image-id');
    console.log(image);
    $("#Image").val(image);
    window.updateRunningCosts();
}


function onChangeFilters(event) {
    const currentDropdown = ($(this).attr("name"));
    if (currentDropdown == "OperatingCycleId") {
        const derivativeId = $("#DerivativeId").val();
        if (parseInt(derivativeId) > 0) {
            const id = $(this).val();
            $.get("/cap-operating-cycles/miles/" + id, function (response) {
                $("#Miles").val(response);
                $.get("/cap-operating-cycles/years/" + id, function (response) {
                    $("#Years").val(response);
                    window.updateRunningCosts();
                });
            });
        } else {
            alert("please select a derivative first");
        }
    } else if (currentDropdown == "DerivativeId") {
        $("#DerivativeId").val($(this).val());
        window.updateRunningCosts();
    }
}


export function setupCarLaunch() {
    if ($('[data-car-launch-running-costs]').length) {
        window.updateRunningCosts = function () {
            updateRunningCostsLogic(1);
        }
        window.loadCarLaunchGallery = function () {
            const sliders = $("[data-car-launch-slider-gallery]");
            if (sliders.length == 0)
                return;
            sliders.each(function (index, element) {
                const $element = $(element);
                if ($element.data('royalSlider') != null)
                    return;
                const slider = $element.royalSlider({
                    arrowsNavAutoHide: false,
                    imageScaleMode: 'fit-if-smaller',
                    imageScalePadding: 0,
                    autoScaleSlider: true,
                    autoScaleSliderWidth: 750,
                    autoScaleSliderHeight: 563,
                    globalCaption: true,
                    controlNavigationSpacing: 0,
                    controlNavigation: "none",
                    loop: true,
                    numImagesToPreload: 1,
                    keyboardNavEnabled: true,
                    usePreloader: false,
                    slidesSpacing: 0,
                    minSlideOffset: 0,
                    thumbs: {
                        arrowsAutoHide: true,
                        spacing: 0
                    }
                });

                const sliderData = slider.data('royalSlider');
                data = sliders.data('car-launch-slider-query-string');
                if (data.image) {
                    for (let i = 0; i < sliderData.slides.length; i++) {
                        const slide = sliderData.slides[i];
                        if (slide.content.data('image-id') == data.image) {
                            // as per http://help.dimsemenov.com/discussions/problems/1373-gotosilent-version-93
                            sliderData.st.transitionSpeed = 0;
                            sliderData.goTo(slide.id);
                            setTimeout(function () {
                                sliderData.st.transitionSpeed = 600;
                            }, 10);
                        }
                    }
                }
                sliderData.ev.on('rsAfterSlideChange', onImageSliderChange);
                window.gallerySliderData = sliderData;
                const siblings = $element.siblings('[data-slider-caption-container]');
                const caption = $element.find('.rsGCaption');
                caption.appendTo(siblings);
            });
            $('.rsNav.rsThumbs.rsThumbsHor').attr("style", "height:auto");
        };
        window.loadCarLaunchGallery();
        setOperatingCycle();
        $(document).on('change', '[data-car-launch-running-costs] select', onChangeFilters);
        //History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
        //    markAsLoading();
        //    reloadQuery();
        //    const State = History.getState();
        //    setTimeout(
        //        function () {
        //            $.get('/car-launch/running-costs/results', State.data, function (response) {
        //                $('#car-launch-results-container').replaceWith(response);
        //            });
        //        }, 500);
        //});
    }
}
